module.exports = __webpack_public_path__ + "img/portraits_10_V.c0dced51.webp";